import BaseComponent from 'scripts/BaseComponent.js';
import Swiper, { Navigation, Autoplay } from 'swiper';

export default class PromobarCarousel extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      swiperContainer: '.js-promoSwiperContainer',
      prevArrow: '.js-promoSwiperPrev',
      nextArrow: '.js-promoSwiperNext',
    };

    this.dom = {
      $component: component,
      $swiperContainer: this.$get(this.refs.swiperContainer),
      $prevArrow: this.$get(this.refs.prevArrow),
      $nextArrow: this.$get(this.refs.nextArrow),
    };

    this.state = {
      swiper: null,
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    const { dom, state } = this;

    state.swiper = new Swiper(dom.$swiperContainer, {
      modules: [Navigation, Autoplay],
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        prevEl: dom.$prevArrow,
        nextEl: dom.$nextArrow,
      },
    });
  }
}
